<template>
    <div class="modal" :class="{ 'is-active': opened }">
        <div
            class="modal-background"
            :class="{ 'is-pointer': allowClose }"
            @click="tryClose"
        ></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">
                    {{ $t("browser-compatibility.title") }}
                </p>
                <button
                    class="delete"
                    v-if="allowClose"
                    @click="close"
                ></button>
            </header>
            <section class="modal-card-body">
                <div
                    class="icon-text mb-2"
                    v-for="(compatibility, index) in compatibilities"
                    :key="index"
                >
                    <span class="icon has-text-info mr-3">
                        <Icon
                            family="fal"
                            :name="getCheckIconName(compatibility.correct)"
                            :helperClass="getColorClass(compatibility.correct)"
                        />
                    </span>
                    {{ $t(`browser-compatibility.${compatibility.titleTag}`) }}
                </div>
            </section>
            <footer class="modal-card-foot">
                <button class="button" v-if="allowClose" @click="close">
                    {{ $t("browser-compatibility.close") }}
                </button>
            </footer>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
    name: "browser-compatibility",
    computed: {
        ...mapGetters("browserCompatibility", [
            "getCompatibilities",
            "getOpened",
            "getAllowClose",
        ]),
        compatibilities() {
            return this.getCompatibilities;
        },
        opened() {
            return this.getOpened;
        },
        allowClose() {
            return this.getAllowClose;
        },
    },
    methods: {
        ...mapActions("browserCompatibility", ["close"]),
        tryClose() {
            if (this.allowClose) {
                this.close();
            }
        },
        getCheckIconName(correct) {
            if (correct) {
                return "fa-check";
            }
            return "fa-times";
        },
        getColorClass(correct) {
            if (correct) {
                return "correct";
            }
            return "wrong";
        },
    },
};
</script>

<style scoped>
.correct {
    color: green;
}

.wrong {
    color: red;
}
</style>